import React, { Component } from 'react';
import { sections } from '../../helpers';
import {strings} from '../../common/translations';
import Section from '../../components/Section'

class SectionRicercaInnovazione extends Component {
    render() {
        return (
            <Section data={sections.RICERCA_INNOVAZIONE}
            		 title={strings.NAVIGATION.SECTION_2.NAME}
            		 description={strings.RICERCA_INNOVAZIONE.DESCRIPTION} />          
        );
    }
}

export default SectionRicercaInnovazione;